/* ==========================================================================
   DRENAJE — Sonido "pfss" al agregar al carrito
   Se engancha al evento pub/sub 'cart-update' nativo de Rise (se dispara
   en el botón normal, en la tabla B2B y en la tabla mixed-caps).
   Incluye anti-saturación: si se agregan muchas latas seguidas, no se
   enciman los sonidos (throttle).
   ========================================================================== */
(function () {
  var SOUND_URL = window.DrenajeCartSoundUrl || '';
  var THROTTLE_MS = 350; // mínimo entre reproducciones
  var lastPlayed = 0;
  var audio = null;
  var unlocked = false;

  if (!SOUND_URL) return;

  // Pre-carga el audio
  function getAudio() {
    if (!audio) {
      audio = new Audio(SOUND_URL);
      audio.preload = 'auto';
      audio.volume = 0.6;
    }
    return audio;
  }

  // Los navegadores bloquean audio hasta la primera interacción del usuario.
  // "Desbloqueamos" reproduciendo en silencio al primer toque/click.
  function unlock() {
    if (unlocked) return;
    var a = getAudio();
    var prevVol = a.volume;
    a.volume = 0;
    a.play().then(function () {
      a.pause();
      a.currentTime = 0;
      a.volume = prevVol;
      unlocked = true;
    }).catch(function () {
      a.volume = prevVol;
    });
    document.removeEventListener('click', unlock);
    document.removeEventListener('touchstart', unlock);
    document.removeEventListener('keydown', unlock);
  }

  document.addEventListener('click', unlock, { once: false });
  document.addEventListener('touchstart', unlock, { once: false });
  document.addEventListener('keydown', unlock, { once: false });

  function playSound() {
    var now = Date.now();
    if (now - lastPlayed < THROTTLE_MS) return; // anti-saturación
    lastPlayed = now;

    var a = getAudio();
    try {
      a.currentTime = 0;
      var p = a.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () { /* navegador bloqueó; se ignora */ });
      }
    } catch (e) { /* no-op */ }
  }

  // Engancha al sistema pub/sub de Rise cuando esté disponible.
  function hookPubSub() {
    if (typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        // Solo sonar cuando el origen es un "agregar" (no al cambiar/eliminar
        // cantidades dentro del carrito). Rise marca el source en algunos casos.
        var src = event && event.source ? event.source : '';
        if (src === 'cart-items') return; // edición dentro del carrito -> sin sonido
        playSound();
      });
      return true;
    }
    return false;
  }

  // Reintenta hasta que pub/sub cargue (constants.js + pub-sub.js)
  if (!hookPubSub()) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (hookPubSub() || tries > 40) clearInterval(iv);
    }, 150);
  }

  // Respaldo: escucha el fetch a /cart/add por si algún flujo no publica el evento.
  // (No imprescindible, pero cubre apps de terceros.)
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var url = arguments[0];
      var isAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
      var result = origFetch.apply(this, arguments);
      if (isAdd) {
        result.then(function (res) {
          if (res && res.ok) {
            // pequeño respaldo solo si pub/sub no sonó hace muy poco
            setTimeout(function () {
              if (Date.now() - lastPlayed > THROTTLE_MS) playSound();
            }, 50);
          }
        }).catch(function () {});
      }
      return result;
    };
  }
})();
